module.exports = __webpack_public_path__ + "img/LOGO_5_1_2.8f81f725.svg";